import React from 'react'
import { Card, CardContent, Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import PresentationCard from 'components/card/PresentationCard'
import ParamTraitementImport from './ParamTraitementImport'
import Input from 'components/forms/Input'


const TraitementImportStartCard = ({
    typeStation,
    setTypeStation,
    choiceTypeCode,
    setChoiceTypeCode,
    listCode,
    changeName,
    pair,
    setPairToSave,
    logo,
    type,
    title,
    listHour,
    setListHour,
    orobnatIsUsed,
}) => {
    const centerStyle = {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    }

    const handleAddType = (newCode) => {
        if (!pair[newCode]) {
            changeName(newCode, `IMPORT START ${title}`)
        }
        setTypeStation(prev =>
            prev.includes(newCode)
                ? prev.filter(x => x !== newCode)
                : [...prev, newCode],
        )
    }

    const params = { choiceTypeCode, setChoiceTypeCode, listCode, typeStation, pair, setPairToSave, listHour, setListHour, orobnatIsUsed }
    return (
        <Card>
            <CardContent>
                <Grid container spacing={3} alignItems='center'>
                    <Grid size={2}>
                        <PresentationCard
                            iconComponent={
                                <img
                                    className='responsive-img'
                                    src={logo}
                                    height={70}
                                    width={70}
                                    style={{
                                        textAlign: 'center',
                                        display: 'table-cell',
                                        verticalAlign: 'middle',
                                    }}
                                />}
                            iconContainerStyle={centerStyle}
                            title= {title}
                            onClick={() => handleAddType(type)}
                            isFocused={typeStation.includes(type)}
                        />
                    </Grid>
                    <Grid size={8}>
                        <ParamTraitementImport
                            {...params}
                            valid={!typeStation.includes(type)}
                            jobtype={type}
                        />
                    </Grid>
                    <Grid size={2}>
                        <Input
                            title={i18n.name}
                            fullWidth
                            disabled={!typeStation.includes(type)}
                            value={pair[type] || `IMPORT START ${title}`}
                            onChange={(e) =>
                                changeName(type, e)
                            }
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

TraitementImportStartCard.propTypes = {
    typeStation: PropTypes.any,
    setTypeStation: PropTypes.func,
    choiceTypeCode: PropTypes.string,
    setChoiceTypeCode: PropTypes.func,
    listCode: PropTypes.any,
    changeName: PropTypes.func,
    pair: PropTypes.any,
    setPairToSave: PropTypes.func,
    handleAddType: PropTypes.func,
    logo: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    listHour: PropTypes.array,
    setListHour: PropTypes.func,
    orobnatIsUsed: PropTypes.bool,
}

export default TraitementImportStartCard